var getContactTypeTranslationKey = function getContactTypeTranslationKey(contactType) {
  return contactType === 'EMAIL' ? 'com.login.2fa.send.contact.email' : 'com.login.2fa.send.contact.phone';
};

export var getSendCodeToLabel = function getSendCodeToLabel(contactType, dictionary) {
  return "".concat(dictionary.t('com.login.2fa.send.code'), " ").concat(dictionary.t(getContactTypeTranslationKey(contactType)));
};
export var getInputDescription = function getInputDescription(isError, remainCheckAttempts, dictionary) {
  if (!remainCheckAttempts) {
    return "".concat(dictionary.t('com.login.2fa.no.tries'));
  }

  var description = '';

  if (isError) {
    description = "".concat(dictionary.t('com.login.2fa.validation.incorrect.code'));
  }

  description += " ".concat(dictionary.t('com.login.2fa.try.left'));
  return description.replace('TRY', "".concat(remainCheckAttempts));
};